export default __webpack_public_path__ + "images/logo.svg?aacd9d3b210245193dee0dc44ec4445c";